import { redoMarketIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod";
import { null as zNull } from "zod";

/**
 * Soft-delete a market and every country row under it, and tear down the
 * associated Shopify resources. Returns 404 if the market id isn't owned
 * by the team.
 */
export const deleteRedoMarket = {
  name: "deleteRedoMarket" as const,
  input: z.object({ marketId: redoMarketIdFormat.schema }),
  output: zNull(),
};
